import styled from "styled-components";

export const DoorAccessContainer = styled.div`
  padding: 4px 16px;
  &:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;
